import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useState, useRef, useEffect, useImperativeHandle } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import ClearableInput, { hasPrefixSuffix } from './ClearableLabeledInput';
import devWarning from '../_utils/devwarning';
import { useMergedState } from '../_utils/hooks';
export var InputSiteTypes = tuple('large', 'middle', 'small');
export var BorderTypes = tuple('none', 'underline', 'bordered');
export function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value;
}
var InternalInput = function InternalInput(props, ref) {
  var _context, _classNames;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var inputProps = getCompProps('Input', userDefaultProps, props);
  var type = inputProps.type,
    size = inputProps.size,
    disabled = inputProps.disabled,
    onPressEnter = inputProps.onPressEnter,
    borderType = inputProps.borderType,
    customPrefixcls = inputProps.prefixCls,
    onFocus = inputProps.onFocus,
    onBlur = inputProps.onBlur,
    onChange = inputProps.onChange,
    placeholderTobeValue = inputProps.placeholderTobeValue,
    defaultValue = inputProps.defaultValue,
    propsValue = inputProps.value,
    className = inputProps.className,
    maxLength = inputProps.maxLength,
    count = inputProps.count,
    status = inputProps.status,
    others = __rest(inputProps, ["type", "size", "disabled", "onPressEnter", "borderType", "prefixCls", "onFocus", "onBlur", "onChange", "placeholderTobeValue", "defaultValue", "value", "className", "maxLength", "count", "status"]);
  devWarning(InputSiteTypes.indexOf(size) === -1, 'input', "cannot found input size '".concat(size, "'"));
  devWarning(BorderTypes.indexOf(borderType) === -1, 'input', "cannot found input borderType '".concat(borderType, "'"));
  var _useMergedState = useMergedState('', {
      value: propsValue,
      defaultValue: defaultValue
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    value = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showNumberMark = _useState4[0],
    setShowNumberMark = _useState4[1];
  var inputRef = useRef();
  var inputPrefixCls = getPrefixCls(prefixCls, 'input', customPrefixcls); // 按钮样式前缀
  var addonBefore = others.addonBefore,
    addonAfter = others.addonAfter;
  var inputClasses = classNames(inputPrefixCls, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(inputPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames, "".concat(inputPrefixCls, "-borderless"), borderType === 'none'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-error"), status === 'error'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames), _defineProperty({}, className, className && !hasPrefixSuffix(inputProps) && !addonBefore && !addonAfter));
  var handleFocus = function handleFocus(event) {
    setFocused(true);
    onFocus && onFocus(event);
  };
  var handleBlur = function handleBlur(event) {
    setFocused(false);
    onBlur && onBlur(event);
  };
  var handleChange = function handleChange(event) {
    propsValue === undefined && setValue(event.target.value);
    onChange && onChange(event);
  };
  var handleReset = function handleReset() {
    setValue('');
    var event = {
      target: {
        value: ''
      }
    };
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus();
      event.target = inputRef.current;
    }
    onChange && onChange(event);
  };
  var handleKeyUp = function handleKeyUp(event) {
    if (onPressEnter && event.key === 'Enter') {
      var newValue = placeholderTobeValue && !value && !defaultValue ? inputProps.placeholder : value || defaultValue;
      onPressEnter && onPressEnter(newValue || '', event);
    }
    inputProps.onKeyUp && inputProps.onKeyUp(event);
  };
  var inputDomProps = _extends({}, others);
  delete inputDomProps.allowClear;
  delete inputDomProps.suffix;
  delete inputDomProps.addonAfter;
  delete inputDomProps.addonBefore;
  delete inputDomProps.className;
  var renderCount = function renderCount() {
    var enteredLength = value ? value.length : 0;
    if (maxLength !== undefined && enteredLength >= maxLength) {
      enteredLength = maxLength;
    }
    if (count && showNumberMark && !disabled) {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("".concat(inputPrefixCls, "-input-mark-inner"))
      }, enteredLength, maxLength !== undefined ? "/".concat(maxLength) : null);
    }
    return null;
  };
  var renderInput = function renderInput() {
    return /*#__PURE__*/React.createElement("input", _extends({
      ref: inputRef,
      type: type,
      disabled: disabled,
      className: inputClasses,
      value: fixControlledValue(value),
      maxLength: maxLength
    }, inputDomProps, {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onKeyUp: handleKeyUp
    }));
  };
  useEffect(function () {
    if (focused && !showNumberMark) {
      setShowNumberMark(true);
    }
    if (!focused && showNumberMark) {
      setShowNumberMark(false);
    }
  }, [focused]);
  useImperativeHandle(ref, function () {
    return {
      input: inputRef.current,
      focus: function focus() {
        var _a;
        setFocused(true);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        setFocused(false);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      },
      select: function select() {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
      }
    };
  });
  return /*#__PURE__*/React.createElement(ClearableInput, _extends({}, inputProps, {
    handleReset: handleReset,
    value: value,
    inputType: "input",
    prefixCls: inputPrefixCls,
    element: renderInput(),
    focused: focused,
    count: count,
    inputCount: renderCount()
  }));
};
var Input = /*#__PURE__*/React.forwardRef(InternalInput);
Input.displayName = 'Input';
export default Input;